export default { MAX_MS_TIME_BETWEEN_HEARTBEATS: 3000 }
